import type { FC } from 'react';
import React from 'react';
import cx from 'classnames';

import PageComposer from 'Components/PageComposer/PageComposer';
import Content from 'Storybook/local/Content/Content';
import { PAGE_SLUGS } from 'Utilities/consts';

import { ProductFooter } from '../ProductPageComponents/ProductFooter/ProductFooter';

import { BenefitsSection } from './BenefitsSection';
import type { DiscoverMWMoveProps } from './DiscoverMWMove.types';
import { FAQSection } from './FAQSection';
import { HeroSection } from './HeroSection';
import { ModalRequestCallback } from './ModalRequestCallback';
import { StraplineSection } from './StraplineSection';
import { useDiscoverMWMove } from './useDiscoverMWMove';

import styles from './DiscoverMWMove.module.scss';

const DiscoverMWMoveContent: FC<DiscoverMWMoveProps> = (params) => {
	const { heroProps, requestCallbackProps, showRequestCallbackModal } = useDiscoverMWMove(params);

	return (
		<>
			<Content
				className={styles.main}
				element="main"
				wrapper={{ className: cx(styles.wrapper, styles.theme) }}
				wrapperContentPre={<HeroSection {...heroProps} />}
			>
				<BenefitsSection />
				<StraplineSection />
				<FAQSection />
			</Content>
			{showRequestCallbackModal && <ModalRequestCallback {...requestCallbackProps} />}
			<ProductFooter
				actions={heroProps.actions}
				className={styles.theme}
				title={
					<>
						Join <strong>Motorway Move</strong> today
					</>
				}
			/>
		</>
	);
};

const DiscoverMWMove: React.FC<DiscoverMWMoveProps> = (params) => (
	<PageComposer showFixedBottomBar fixedBottomBarClassName={styles.fixedBottomBar} pageSlug={PAGE_SLUGS.MOTORWAY_MOVE}>
		<DiscoverMWMoveContent {...params} />
	</PageComposer>
);

export default DiscoverMWMove;
